import { Context } from "ripple"


export const RouteContext = new Context()